import { render, staticRenderFns } from "./mainheader.vue?vue&type=template&id=020b414e&"
import script from "./mainheader.vue?vue&type=script&defer=true&lang=js&"
export * from "./mainheader.vue?vue&type=script&defer=true&lang=js&"
import style0 from "./mainheader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports